import React, { useEffect } from "react";
import cx from "classnames";
import styles from "./SearchPageList.module.css";

const SearchPageList = ({ value, setValue }) => {
  return (
    <div
      className={cx(
        styles.searchWrapperOuter,
        "w-100",
        "align-items-center",
        "justify-content-center",
        "position-relative"
      )}
    >
      <input
        className={cx(styles.inputStyles, "d-flex", "w-100", "h-100")}
        placeholder="جستجو..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <button
        className={cx(
          styles.searchBtn,
          "d-none",
          "d-md-flex",
          "align-items-center",
          "justify-content-center",
          "position-absolute"
        )}
      >
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6" cy="6" r="5.5" stroke="#212121" />
          <path d="M10 10L16.5 16.5" stroke="#212121" strokeLinecap="round" />
        </svg>
      </button>
      {false && (
        <button
          className={cx(
            styles.cancelBtn,
            "d-flex",
            "align-items-center",
            "justify-content-center",
            "position-absolute"
          )}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1421 15.1421L1 1"
              stroke="#212121"
              strokeLinecap="round"
            />
            <path
              d="M15.1421 1.00825L1 15.1504"
              stroke="#212121"
              strokeLinecap="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default SearchPageList;
